import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetSubObjectivesById = createAsyncThunk(
  "GetSubObjectivesById/GetSubObjectivesById",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SubObjectives/GetSpecifiicRowSubObjectives",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteSubObjectives = createAsyncThunk(
  "DeleteSubObjectives/DeleteSubObjectives",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SubObjectives/DeleteSubObjectives",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateSubObjectives = createAsyncThunk(
  "UpdateSubObjectives/UpdateSubObjectives",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SubObjectives/EditSubObjectives",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddSubObjectives = createAsyncThunk(
  "AddSubObjectives/AddSubObjectives",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SubObjectives/AddSubObjectives",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateSubObjectives = createAsyncThunk(
  "ValidateSubObjectives/ValidateSubObjectives",
  async (Validate, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SubObjectives/ValidateSubObjectives",
        {
          subObjectivesName: Validate.subObjectivesName,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const SubObjectives = createSlice({
  name: "SubObjectives",
  initialState: {
    SubObjectives: {},
    loadingSubObjectives: false,
    errorSubObjectives: null,

    AddSubObjectives: {},
    loadingAddSubObjectives: false,
    errorAddSubObjectives: null,

    UpdateSubObjectives: {},
    loadingUpdateSubObjectives: false,
    errorUpdateSubObjectives: null,

    DeleteSubObjectives: {},
    loadingDeleteSubObjectives: false,
    errorDeleteSubObjectives: null,

    SubObjectivesValidate: [],
    loadingSubObjectivesValidate: false,
    errorSubObjectivesValidate: null,
  },
  reducers: {
    restValidateSubObjectives: (state, action) => {
      state.SubObjectivesValidate = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(GetSubObjectivesById.pending, (state, action) => {
        state.loadingSubObjectives = true;
        state.SubObjectives = action.payload;
        state.errorSubObjectives = null;
      })
      .addCase(GetSubObjectivesById.fulfilled, (state, action) => {
        state.loadingSubObjectives = false;
        state.SubObjectives = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetSubObjectivesById.rejected, (state, action) => {
        state.loadingSubObjectives = false;
        state.errorSubObjectives = action.payload;
      })

      .addCase(DeleteSubObjectives.pending, (state, action) => {
        state.loadingDeleteSubObjectives = true;
        state.DeleteSubObjectives = action.payload;
        state.errorDeleteSubObjectives = null;
      })
      .addCase(DeleteSubObjectives.fulfilled, (state, action) => {
        state.loadingDeleteSubObjectives = false;
        state.DeleteSubObjectives = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteSubObjectives.rejected, (state, action) => {
        state.loadingDeleteSubObjectives = false;
        state.errorDeleteSubObjectives = action.payload;
      })

      .addCase(UpdateSubObjectives.pending, (state, action) => {
        state.loadingUpdateSubObjectives = true;
        state.UpdateSubObjectives = action.payload;
        state.errorUpdateSubObjectives = null;
      })
      .addCase(UpdateSubObjectives.fulfilled, (state, action) => {
        state.loadingUpdateSubObjectives = false;
        state.UpdateSubObjectives = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateSubObjectives.rejected, (state, action) => {
        state.loadingUpdateSubObjectives = false;
        state.errorUpdateSubObjectives = action.payload;
      })

      .addCase(AddSubObjectives.pending, (state, action) => {
        state.loadingAddSubObjectives = true;
        state.AddSubObjectives = action.payload;
        state.errorAddSubObjectives = null;
      })
      .addCase(AddSubObjectives.fulfilled, (state, action) => {
        state.loadingAddSubObjectives = false;
        state.AddSubObjectives = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddSubObjectives.rejected, (state, action) => {
        state.loadingAddSubObjectives = false;
        state.errorAddSubObjectives = action.payload;
      })
      .addCase(ValidateSubObjectives.pending, (state, action) => {
        state.loadingSubObjectivesValidate = true;
        state.SubObjectivesValidate = action.payload;
        state.errorSubObjectivesValidate = null;
      })
      .addCase(ValidateSubObjectives.fulfilled, (state, action) => {
        state.loadingSubObjectivesValidate = false;
        state.SubObjectivesValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateSubObjectives.rejected, (state, action) => {
        state.loadingSubObjectivesValidate = false;
        state.errorSubObjectivesValidate = action.payload;
      });
  },
});
export const { restValidateSubObjectives } = SubObjectives.actions;
export default SubObjectives.reducer;
